import { Model } from "echarts/lib/export";
import { message, Modal, Button, Form } from 'antd';

function addCookie(name, value, days, path) {   /**添加设置cookie**/
    var name = escape(name);
    var value = escape(value);
    var expires = new Date();
    expires.setTime(expires.getTime() + days * 3600000 * 24);
    //path=/，表示cookie能在整个网站下使用，path=/temp，表示cookie只能在temp目录下使用  
    path = path == "" ? "" : ";path=" + path;
    //GMT(Greenwich Mean Time)是格林尼治平时，现在的标准时间，协调世界时是UTC  
    //参数days只能是数字型  
    var _expires = (typeof days) == "string" ? "" : ";expires=" + expires.toUTCString();
    document.cookie = name + "=" + value + _expires + path;
}
function getCookieValue(name) {  /**获取cookie的值，根据cookie的键获取值**/
    //用处理字符串的方式查找到key对应value  
    var name = escape(name);
    //读cookie属性，这将返回文档的所有cookie  
    var allcookies = document.cookie;
    //查找名为name的cookie的开始位置  
    name += "=";
    var pos = allcookies.indexOf(name);
    //如果找到了具有该名字的cookie，那么提取并使用它的值  
    if (pos != -1) {                                             //如果pos值为-1则说明搜索"version="失败  
        var start = pos + name.length;                  //cookie值开始的位置  
        var end = allcookies.indexOf(";", start);        //从cookie值开始的位置起搜索第一个";"的位置,即cookie值结尾的位置  
        if (end == -1) end = allcookies.length;        //如果end值为-1说明cookie列表里只有一个cookie  
        var value = allcookies.substring(start, end); //提取cookie的值  
        return (value);                           //对它解码        
    } else {  //搜索失败，返回空字符串  
        return "";
    }
}
function deleteCookie(name, path) {   /**根据cookie的键，删除cookie，其实就是设置其失效**/
    var name = escape(name);
    var expires = new Date(0);
    path = path == "" ? "" : ";path=" + path;
    document.cookie = name + "=" + ";expires=" + expires.toUTCString() + path;
}

function formatNumber(n) {
    n = n.toString()
    return n[1] ? n : '0' + n
}
//加法   
Number.prototype.add = function (arg) {
    var r1, r2, m;
    try { r1 = this.toString().split(".")[1].length } catch (e) { r1 = 0 }
    try { r2 = arg.toString().split(".")[1].length } catch (e) { r2 = 0 }
    m = Math.pow(10, Math.max(r1, r2))
    return (this * m + arg * m) / m
}
//减法   
Number.prototype.sub = function (arg) {
    return this.add(-arg);
}
//乘法   
Number.prototype.mul = function (arg) {
    var m = 0, s1 = this.toString(), s2 = arg.toString();
    try { m += s1.split(".")[1].length } catch (e) { }
    try { m += s2.split(".")[1].length } catch (e) { }
    return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)
}
//除法   
// Number.prototype.div = function (arg) {
//     var t1 = 0, t2 = 0, r1, r2;
//     try { t1 = this.toString().split(".")[1].length } catch (e) { }
//     try { t2 = arg.toString().split(".")[1].length } catch (e) { }
//     with (Math) {
//         r1 = Number(this.toString().replace(".", ""))
//         r2 = Number(arg.toString().replace(".", ""))
//         return (r1 / r2) * pow(10, t2 - t1);
//     }
// }
function formatTimestamp(timestamp, type, CHflag) {
    var date = new Date();
    date.setTime(timestamp);

    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var day = date.getDate()
    var hour = date.getHours()
    var minute = date.getMinutes()
    var second = date.getSeconds()

    switch (type) {
        case 'date':
            if (CHflag) {
                return formatNumber(year) + "年" + formatNumber(month) + "月" + formatNumber(day) + '日';
            };
            return formatNumber(year) + "-" + formatNumber(month) + "-" + formatNumber(day);
        case 'time':
            return formatNumber(hour) + ":" + formatNumber(minute);
        case 'monthDate':
            return formatNumber(month) + "-" + formatNumber(day);
        case 'yearMonth':
            return formatNumber(year) + "-" + formatNumber(month);
        default:
            return formatNumber(year) + "/" + formatNumber(month) + "/" + formatNumber(day) + " " + formatNumber(hour) + ":" + formatNumber(minute) + ":" + formatNumber(second);
    }
}
function myFormatTimestamp(timestamp, type, CHflag) {
    var date = new Date();
    date.setTime(timestamp);

    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var day = date.getDate()
    var hour = date.getHours()
    var minute = date.getMinutes()
    var second = date.getSeconds()

    switch (type) {
        case 'date':
            if (CHflag) {
                return formatNumber(year) + "年" + formatNumber(month) + "月" + formatNumber(day) + '日';
            };
            return formatNumber(year) + "-" + formatNumber(month) + "-" + formatNumber(day);
        case 'time':
            return formatNumber(hour) + ":" + formatNumber(minute);
        case 'monthDate':
            return formatNumber(month) + "-" + formatNumber(day);
        case 'yearMonth':
            return formatNumber(year) + "-" + formatNumber(month);
        default:
            return formatNumber(year) + "-" + formatNumber(month) + "-" + formatNumber(day) + " " + formatNumber(hour) + ":" + formatNumber(minute) + ":" + formatNumber(second);
    }
}


//获取当前日期的周开始时间和结束时间
function getWeekRange(datevalue) {
    var dateValue = datevalue;
    var arr = dateValue.split("-")
    //月份-1 因为月份从0开始 构造一个Date对象
    var date = new Date(arr[0], arr[1] - 1, arr[2]);

    var dateOfWeek = date.getDay();//返回当前日期的在当前周的某一天（0～6--周日到周一）

    var dateOfWeekInt = parseInt(dateOfWeek, 10);//转换为整型

    if (dateOfWeekInt == 0) {//如果是周日
        dateOfWeekInt = 7;
    }
    var aa = 7 - dateOfWeekInt;//当前于周末相差的天数

    var temp2 = parseInt(arr[2], 10);//按10进制转换，以免遇到08和09的时候转换成0
    var sunDay = temp2 + aa;//当前日期的周日的日期
    var monDay = sunDay - 6//当前日期的周一的日期

    var startDate = new Date(arr[0], arr[1] - 1, monDay);
    var endDate = new Date(arr[0], arr[1] - 1, sunDay);

    var sm = parseInt(startDate.getMonth()) + 1;//月份+1 因为月份从0开始
    var em = parseInt(endDate.getMonth()) + 1;

    //  alert("星期一的日期："+startDate.getFullYear()+"-"+sm+"-"+startDate.getDate());
    //  alert("星期日的日期："+endDate.getFullYear()+"-"+em+"-"+endDate.getDate());
    var start = startDate.getFullYear() + "-" + sm + "-" + startDate.getDate();
    var end = endDate.getFullYear() + "-" + em + "-" + endDate.getDate();
    var result = new Array();
    result.push(start);
    result.push(end);

    return result;
}

const changeColor = (variableName, colorCode) => {
    window.less.modifyVars({
        [variableName]: colorCode
    });
}
function treeFilter(list, key, value, childrenKey = 'children') {
    return new Promise(resolve => {
        list.find(item => {
            const value_1 = item[key].split('/')
            // if (item[key] === '/createTopic1/:eqit') {
            //     resolve(item)
            // }
            if (value_1[1] === value.split('/')[1]) {
                resolve(item)
            }
            if (item[childrenKey] && item[childrenKey].length > 0) {
                treeFilter(item[childrenKey], key, value, childrenKey).then(data => {
                    if (data) resolve(data)
                })
            }
        })
    })
}

// 转为百分号，保留小数点  
function toPercent(num, total) {
    return (Math.round(parseFloat(num) / parseFloat(total) * 10000) / 100.00 + "%");// 小数点后两位百分比
}
function revertUTF8(szInput) {
    var x, wch, wch1, wch2, uch = "", szRet = "";
    for (x = 0; x < szInput.length; x++) {
        if (szInput.charAt(x) == "%") {
            wch = parseInt(szInput.charAt(++x) + szInput.charAt(++x), 16);
            if (!wch) { break; }
            if (!(wch & 0x80)) {
                wch = wch;
            }
            else if (!(wch & 0x20)) {
                x++;
                wch1 = parseInt(szInput.charAt(++x) + szInput.charAt(++x), 16);
                wch = (wch & 0x1F) << 6;
                wch1 = wch1 & 0x3F;
                wch = wch + wch1;
            }
            else {
                x++;
                wch1 = parseInt(szInput.charAt(++x) + szInput.charAt(++x), 16);
                x++;
                wch2 = parseInt(szInput.charAt(++x) + szInput.charAt(++x), 16);
                wch = (wch & 0x0F) << 12;
                wch1 = (wch1 & 0x3F) << 6;
                wch2 = (wch2 & 0x3F);
                wch = wch + wch1 + wch2;
            }
            szRet += String.fromCharCode(wch);
        }
        else {
            szRet += szInput.charAt(x);
        }
    }
    return (szRet);
}
function toXHR(url) {
    var xhr = new XMLHttpRequest();
    var formData = new FormData();
    xhr.open('get', url);  //url填写后台的接口地址，如果是post，在formData append参数（参考原文地址）
    xhr.setRequestHeader("token", `${JSON.parse(localStorage.getItem('user')).token}`);
    xhr.responseType = 'blob';
    xhr.onload = function (e) {
        if (this.status == 200) {
            var blob = this.response;
            console.log(this.response)
            if (this.response.type === 'application/json') {
                Modal.error({
                    content: "文件下载失败！"
                })
                return
            }
            // let str = xhr.getResponseHeader('content-disposition').split(";")[1].split("filename=")[1]
            // var filename = decodeURI(escape(str))
            // console.log(filename)
            var filename = xhr.getResponseHeader('content-disposition').split(";")[1].split("filename=")[1];  //这里的名字，可以按后端给的接口固定表单设置一下名字，如（费用单.xlsx,合同.doc等等）
            console.log(this)
            if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, filename);
            } else {
                var a = document.createElement('a');
                var url = URL.createObjectURL(blob);
                a.href = url;
                a.download = revertUTF8(filename);
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            }

        }
    };
    xhr.send(formData);
}


// 金额格式化
function toThousands(num) {
    var result = '', counter = 0;
    let numStr = (num || 0).toString();
    let numArr = numStr.split('.');
    num = numArr[0];
    for (var i = numArr[0].length - 1; i >= 0; i--) {
        counter++;
        result = numArr[0].charAt(i) + result;
        if (!(counter % 3) && i != 0) { result = ',' + result; }
    }
    return result + (numArr[1] ? ('.' + numArr[1].substring(0, 2)) : '.00');
}

function formatSize(num, unitInd = 0) {
    let unit = ['B', 'KB', 'M', 'G', 'T', 'E'];
    num = parseInt(num);
    if (num / 1024 > 1024) {
        unitInd++
        return formatSize(num / 1024, unitInd)
    }
    return num + unit[unitInd]
}

//js下载文件流
function downBlobFile(blob, fileName) {
    if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename);
    } else {
        var a = document.createElement('a');
        blob.type = "application/zip";
        var url = createObjectURL(blob);
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
    }
}
//js下载文件图片解决不同源
function download(urls, names) {
    let url = urls
    let name = names
    // 发送http请求，将文件链接转换成文件流
    fileAjax(url, (xhr) => {
        downloadFile(xhr.response, name)
    }, {
        responseType: 'blob'
    })
}
function fileAjax(url, callback, options) {
    let xhr = new XMLHttpRequest()
    xhr.open('get', url, true)
    // xhr.setRequestHeader("token", `${JSON.parse(localStorage.getItem('user')).token}`);
    if (options.responseType) {
        xhr.responseType = options.responseType
    }
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
            callback(xhr)
        }
    }
    xhr.send()
}
function downloadFile(content, filename) {
    window.URL = window.URL || window.webkitURL
    let a = document.createElement('a')
    let blob = new Blob([content])
    // 通过二进制文件创建url
    let url = window.URL.createObjectURL(blob)
    a.href = url
    a.download = filename
    a.click()
    // 销毁创建的url
    window.URL.revokeObjectURL(url)
}


function exportBlob(blob, filename, callback) {
    console.log(blob)
    let blobUrl = window.URL.createObjectURL(blob);
    const aElement = document.createElement('a');
    document.body.appendChild(aElement);
    aElement.style.display = 'none';
    aElement.href = blobUrl;
    aElement.download = filename;
    aElement.click();
    document.body.removeChild(aElement);
    if (callback) callback()
}

const utils = {
    addCookie: addCookie,
    getCookieValue: getCookieValue,
    deleteCookie: deleteCookie,
    formatTimestamp: formatTimestamp,
    getWeekRange: getWeekRange,
    changeColor: changeColor,
    formatNumber: formatNumber,
    myFormatTimestamp: myFormatTimestamp,
    toPercent: toPercent,
    toThousands: toThousands,
    formatSize: formatSize,
    downBlobFile: downBlobFile,
    exportBlob: exportBlob,
    treeFilter,
    download,
    toXHR
}
export default utils;